import { useId } from 'react';
import { Button, Tooltip } from '@nazka/nazka.mapframe.components';

import './nav-item.css';

function NavItem({ children, icon, iconSize = '18px', isCollapsed, active = false, href, onClick, tooltip = children, showTooltip = isCollapsed, tooltipOpenOnClick = false, tooltipClickable = false, tooltipClassName, tooltipPlace }) {
  const tooltipId = `nav-item-${useId()}`;

  const button = (
    <Button
      className="nav-item__button"
      onClick={onClick ? onClick : null}
      href={href ? href : null}
      icon={icon}
      iconSize={iconSize}
      rootElProps={{
        'data-tooltip-id': tooltipId,
        'data-nav-active': active ? 'true' : undefined,
      }}
    >
      {!isCollapsed && children}
      <span />
    </Button>
  );

  return (
    <div className="nav-item">
      {showTooltip && (
        <Tooltip
          id={tooltipId}
          clickable={tooltipClickable}
          className={tooltipClassName}
          noArrow
          offset={0}
          opacity={1}
          openOnClick={tooltipOpenOnClick}
          place={tooltipPlace}
          tooltip={tooltip}
        >
          {button}
        </Tooltip>
      )}
      {!showTooltip && button}
    </div>
  );
}

export default NavItem;
